<template>
  <div class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h3 fw-semibold mb-0" v-if="!viewByStore">Order Fulfillment</h1>

      <div v-if="!viewByStore" class="d-flex align-items-center">
        <button class="btn btn-sm btn-outline-secondary me-2" @click="clearFilters">Clear Filters</button>
        <button class="btn btn-sm btn-outline-secondary me-2" @click="load">Refresh</button>
      </div>
    </div>

    <div class="card mb-3" v-if="!viewByStore">
      <div class="card-body">
        <div class="row g-2">

          <div class="col">
            <select v-model="filters.location" class="form-select">
              <option value="">All Locations</option>
              <option v-for="name in uniqueLocations" :key="name" :value="name">
                {{ name }}
              </option>
            </select>
          </div>

          <div class="col">
            <select v-model="filters.status" class="form-select">
              <option value="">All Status</option>
              <option value="open">Open</option>
              <option value="delivering">Delivering</option>
              <option value="fulfilled">Fulfilled</option>
            </select>
          </div>

          <div class="col">
            <input v-model="filters.qr" class="form-control" placeholder="Filter by QR Code" />
          </div>
          <div class="col">
            <input type="date" v-model="filters.dateFrom" class="form-control" />
          </div>
          <div class="col">
            <input type="date" v-model="filters.dateTo" class="form-control" />

          </div>
        </div>
      </div>
    </div>

    <br v-if="!viewByStore"><br v-if="!viewByStore">

    <div v-if="loadError" class="alert alert-danger">Failed to load requests. Check console.</div>
    <div v-if="rows.length === 0 && !loadError" class="text-muted">No requests loaded. Click Refresh to try again.</div>

    <div class="mb-3 d-flex align-items-center justify-content-between">
      <div>
        <button class="btn btn-sm btn-outline-primary me-2" @click="toggleStoreView">
          <span v-if="viewByStore">View By Category</span>
          <span v-else>View By Store</span>
        </button>
      </div>
      <div v-if="viewByStore" class="d-flex align-items-center">
        <select v-model.number="selectedYear" class="form-select form-select-sm me-2">
          <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
        </select>
        <select v-model.number="selectedMonth" class="form-select form-select-sm me-2">
          <option v-for="(m, idx) in months" :key="idx" :value="idx + 1">{{ m }}</option>
        </select>
      </div>
    </div>

    <div v-if="viewByStore" class="store-view-overlay" @mouseenter="showStoreOverlayControls = true"
      @mousemove="showStoreOverlayControls = true" @mouseleave="startStoreOverlayHide">
      <button class="btn btn-outline-dark rounded-pill overlay-back-button"
        :class="{ 'overlay-back-button-visible': showStoreOverlayControls }" @click.stop="toggleStoreView">
        View By Category
      </button>

      <div class="card store-view-shell">
        <div class="card-body store-view-body">



          <!-- <div v-if="headerCats && headerCats.length" class="mb-2" style="  height: .3rem">
            <div class="btn-group btn-group-sm flex-wrap">
              <button v-for="cat in headerCats" :key="cat.name" class="btn btn-outline-primary"
                @click="scrollToCategory(cat.name)" style= "height: .3rem">
                {{ cat.name }}
              </button>
            </div>
          </div> -->

          <div v-if="fulfillmentLoading" class="text-muted">Loading...</div>

          <div v-else class="store-table-wrapper"
            style="  white-space: nowrap; overflow: auto; width: 100%; max-width: 100%; padding-top: 0;">
            <div v-if="(headerLeaves && headerLeaves.length > 0) && (locations && locations.length > 0)"
              class="fulfillment-container d-flex" @mouseleave="hoveredStore = null">

              <div class="fulfillment-fixed" ref="leftScroll">
                <table ref="leftTable" class="table table-sm table-bordered align-middle fixed-table">
                  <thead>
                    <tr>
                      <th class="invisible-header">Category</th>
                    </tr>
                    <tr>
                      <th class="invisible-header" height="100%">Item</th>
                    </tr>
                    <tr>

                      <th rowspan="3" class="col-store" style="font-weight: bold">Store</th>
                      <!-- <th rowspan="3" class="col-notes">Notes</th> -->
                    </tr>
                  </thead>


                  <tbody>
                    <tr v-for="(store, i) in storeList" :key="store" :data-row-index="i"
                      :class="{ 'fixed-crew-row': store === 'Fixed Crew', 'hovered-store-row': hoveredStore === store }"
                      @mouseenter="hoveredStore = store">


                      <td class="text-start" style="font-weight: bold">
                        {{ formatStoreDisplay(store, storeAbbrev[store]) }}
                      </td>


                      <!-- <td class="col-notes">
                        <button class="btn btn-sm btn-outline-info" @click="openNotes(store)">Notes</button>
                      </td> -->
                    </tr>

                    <tr class="fw-bold bg-light" data-row-index="total"
                      :class="{ 'hovered-total-row': hoveredStore === 'total' }" @mouseenter="hoveredStore = 'total'">
                      <td colspan="4" class="text-center">Totals:</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="fulfillment-scroll" ref="rightScroll" @scroll="onRightScroll">
                <table ref="rightTable" class="table table-sm table-bordered align-middle fulfillment-table">
                  <thead>
                    <tr>
                      <th v-for="cat in headerCats" :key="cat.name" :colspan="cat.colspan" class="text-center">
                        {{ cat.name }}
                      </th>
                    </tr>

                    <tr>
                      <th v-for="item in headerItems" :key="item.key" :colspan="item.colspan"
                        class="item-header leaf-divider">
                        {{ item.name }}
                      </th>

                      <th class="item-header leaf-divider">Truck Space Delivery</th>
                    </tr>

                    <tr>
                      <th v-for="leaf in headerLeaves" :key="leaf.key" class="text-center"
                        :class="{ 'leaf-divider': isLastLeafOfItem(leaf) }">
                        {{ leaf.name }}
                      </th>

                      <th class="text-center leaf-divider"></th>
                    </tr>
                  </thead>

                  <tbody>

                    <tr v-for="(store, i) in storeList" :key="store" :data-row-index="i"
                      :class="{ 'fixed-crew-row': store === 'Fixed Crew', 'hovered-store-row': hoveredStore === store }"
                      @mouseenter="hoveredStore = store">

                      <td v-for="leaf in headerLeaves" :key="leaf.key" class="text-center" :class="{
                        'leaf-divider': isLastLeafOfItem(leaf),

                        'text-secondary': ((matrix?.[store]?.[leaf.key]) ?? 0) === 0,
                        'text-primary': ((matrix?.[store]?.[leaf.key]) ?? 0) !== 0 && !hasPreviousDayContribution(store, leaf.key),
                        'text-danger': hasPreviousDayContribution(store, leaf.key),

                        'background-black':
                          store !== 'Fixed Crew' &&
                          leaf.key.startsWith('Fixed_Crew||'),

                        'text-dark': store !== 'Fixed Crew' &&
                          leaf.key.startsWith('Fixed_Crew||'),

                      }">
                        {{ (matrix?.[store]?.[leaf.key]) ?? 0 }}
                      </td>


                      <td class="text-center fw-bold leaf-divider">
                        {{ ((truckSpace[store] / 20) * 100).toFixed(1) }}%
                      </td>
                    </tr>

                    <tr class="fw-bold bg-light totals-row" data-row-index="total"
                      :class="{ 'hovered-total-row': hoveredStore === 'total' }" @mouseenter="hoveredStore = 'total'">
                      <td v-for="leaf in headerLeaves" :key="'total-' + leaf.key" class="text-center"
                        :class="{ 'leaf-divider': isLastLeafOfItem(leaf) }">
                        {{ columnTotals[leaf.key] || 0 }}
                      </td>


                    </tr>
                  </tbody>
                </table>
              </div>


            </div>

            <div v-else class="text-muted">
              No categories or locations loaded to display table.
            </div>
          </div>



        </div>


      </div>

      <div class="mb-2">
        <div class="btn-group" role="tablist" style=" height: relative">
          <button v-for="d in daysInMonthRef" :key="d" class="btn btn-sm"
            :class="{ 'btn-outline-secondary': selectedDay !== d, 'btn-secondary': selectedDay === d }"
            @click="selectDay(d); loadFulfillmentDay(d)">
            {{ d }}
          </button>
        </div>
        <!-- <button class="btn btn-sm btn-outline-primary ms-2" @click="loadFulfillmentDay" style=" height: relative">
          Load
        </button> -->


        <!-- <button class="btn btn-sm btn-outline-secondary me-2" @click="clearFilters">Clear Filters</button> -->
        <button class="btn btn-sm btn-outline-secondary me-2" @click="load" style=" height: relative">Refresh</button>

      </div>

      <div v-if="notesModalOpen" class="modal fade show" tabindex="-1"
        style="display:block; background: rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Notes for {{ notesModalStore }} on {{ selectedDateString }}
              </h5>
              <button type="button" class="btn-close" @click="closeNotes"></button>
            </div>
            <div class="modal-body">
              <div v-if="notesLoading" class="text-muted">Loading notes...</div>
              <div v-else-if="!notesList.length" class="text-muted">
                No comments found for this store and date.
              </div>
              <ul v-else class="list-group">
                <li v-for="n in notesList" :key="n.id" class="list-group-item">
                  <strong>
                    {{ n.abbrev }} - {{ formatNoteDate(n.created_at) }}:
                  </strong>
                  {{ n.comments }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-for="cat in displayCategories" :key="cat" class="mb-4 category-panel">
      <div class="card" v-if="!viewByStore">
        <div class="card-header d-flex justify-content-between align-items-center" @click="toggleCategory(cat)"
          style="cursor:pointer">
          <strong>{{ formatCategoryName(cat) }}</strong>
          <div>
            <small class="text-muted me-3">{{ totalCount(cat) }} requests</small>
            <button class="btn btn-sm" @click.stop="toggleCategory(cat)">
              <span v-if="expanded[cat]">▾</span>
              <span v-else>▸</span>
            </button>
          </div>
        </div>

        <div v-show="expanded[cat]" class="card-body">
          <div v-if="totalCount(cat) === 0" class="text-muted">No requests for this category.</div>

          <div v-else>
            <div class="category-table-layout">
              <div class="table-responsive category-table-content">
                <table class="table table-sm table-striped align-middle">
                  <thead>
                    <tr>
                      <th>Store</th>
                      <th>Order</th>
                      <th>Date Submitted</th>
                      <th>Item</th>
                      <th>Requested</th>
                      <th>Delivered</th>
                      <th>Fulfilled</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="it in pagedItems(cat).list" :key="it.donation_item_id">
                      <td>{{ formatCategoryStoreDisplay(it.store) }}</td>
                      <td>
                        <router-link class="order-link"
                          :to="{ name: 'AdminTicketDetail', params: { qr: it.unique_qr_code } }">{{
                            it.unique_qr_code }}</router-link>
                      </td>
                      <td>{{ formatDate(it.created_at) }}</td>
                      <td>{{ cleanName(it.category_name) }} {{ it.bin_type || '' }}</td>
                      <td>{{ it.quantity }}</td>
                      <td>{{ it.delivered_quantity || 0 }}</td>
                      <td>{{ it.fulfilled }}</td>
                      <td><span class="badge text-white" :class="statusColor(it)">
                          {{ statusLabel(it) }}
                        </span>

                      </td>
                      <td>
                        <input type="number" min="0" class="form-control form-control-sm d-inline w-50"
                          v-model.number="sendQuantities[it.donation_item_id]"
                          :disabled="!canSendDelivery(it) || sending[it.donation_item_id]"
                          :class="{ 'opacity-50': !canSendDelivery(it) }" />
                        <button class="btn btn-sm btn-dark ms-2"
                          :disabled="!canSendDelivery(it) || sending[it.donation_item_id] || !(sendQuantities[it.donation_item_id] > 0)"
                          @click="sendItem(it)">Send</button>
                        <!-- <button class="btn btn-sm btn-success ms-2" :disabled="completing[it.donation_item_id] || (it.fulfilled >= it.quantity)" @click="completeItem(it)">
                        <span v-if="completing[it.donation_item_id]">Working...</span>
                        <span v-else>Complete</span>
                      </button> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
        <div v-if="expanded[cat] && pagedItems(cat).totalPages > 1" class="card-footer category-pagination-footer">
          <div class="btn-group" role="tablist" style="height: relative">
            <button v-for="page in pageNumbers(cat)" :key="page" type="button" class="btn btn-sm"
              :class="{ 'btn-outline-secondary': pagedItems(cat).page !== page, 'btn-secondary': pagedItems(cat).page === page }"
              @click="goToPage(cat, page)">
              {{ page }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue';
import axios from 'axios';
import { formatSanDiegoDateTime } from '../utils/dateTime';

const allowedCategories = [
  'Requested_Product',
  'Product_For_Reallocation',
  'Product_On_Hand',
  'Donation_Info',
  'Delivered_Product',
  'Actually_Reallocated',
  'Fixed_Crew'

];

const tableViewCategories = [
  'Requested_Product',
  'Fixed_Crew',

  // 'Product_For_Reallocation',
];

function formatStoreDisplay(fullName, abbrev) {
  if (!fullName) return "";

  const name = fullName.trim();
  let city = name;
  let typeShort = "";

  if (name.endsWith("Retail Store")) {
    city = name.replace("Retail Store", "").trim();
    typeShort = "Retail";
  } else if (name.endsWith("Donation Center")) {
    city = name.replace("Donation Center", "").trim();
    typeShort = "DC";
  } else if (name.endsWith("Outlet Center")) {
    city = name.replace("Outlet Center", "").trim();
    typeShort = "Outlet";
  } else {
    return abbrev ? `${name} - ${abbrev}` : name;
  }

  return abbrev ? `${city} ${typeShort} - ${abbrev}` : `${city} ${typeShort}`;
}

function formatCategoryStoreDisplay(fullName) {
  if (!fullName) return "";

  const name = fullName.trim();
  if (name.toLowerCase() === 'fixed crew') return 'fixed crew';

  if (name.endsWith("Retail Store")) {
    return `${name.replace("Retail Store", "").trim()} Retail`;
  }

  if (name.endsWith("Donation Center")) {
    return `${name.replace("Donation Center", "").trim()} DC`;
  }

  if (name.endsWith("Outlet Center")) {
    return `${name.replace("Outlet Center", "").trim()} Outlet`;
  }

  return name;
}

function isLastLeafOfItem(leaf) {
  const [cat, item] = leaf.key.split("||");

  const leavesForItem = headerLeaves.value.filter(l => {
    const [c, i] = l.key.split("||");
    return c === cat && i === item;
  });

  return leavesForItem[leavesForItem.length - 1].key === leaf.key;
}


const rows = ref([]);
const loadError = ref(false);
const filters = ref({ q: '', location: '', qr: '', dateFrom: '', dateTo: '', status: '' });

const expanded = ref({});
const perCategoryPage = ref({});


const defaultInitial = 20;
const sendQuantities = ref({});
const sending = ref({});
const locations = ref([]);
const storeAbbrev = ref({});

const viewByStore = ref(false);
const showStoreOverlayControls = ref(false);
const categoriesTree = ref([]);
const fulfillmentRows = ref([]);
const fulfillmentLoading = ref(false);
const hoveredStore = ref(null);
let storeOverlayTimer = null;
let refreshInterval = null;

const today = new Date();
const selectedYear = ref(today.getFullYear());
const selectedMonth = ref(today.getMonth() + 1);
const selectedDay = ref(today.getDate());

const years = Array.from({ length: 5 }).map((_, i) => today.getFullYear() - (4 - i));
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

const daysInMonthRef = computed(() => {
  return Array.from({ length: daysInMonth(selectedYear.value, selectedMonth.value) }, (_, i) => i + 1);
});

function selectDay(d) {
  selectedDay.value = d;
}

function toggleStoreView() {
  viewByStore.value = !viewByStore.value;
  showStoreOverlayControls.value = false;
}

function startStoreOverlayHide() {
  if (storeOverlayTimer) clearTimeout(storeOverlayTimer);
  storeOverlayTimer = window.setTimeout(() => {
    showStoreOverlayControls.value = false;
  }, 1200);
}

const selectedDateString = computed(() => {
  const y = selectedYear.value;
  const m = String(selectedMonth.value).padStart(2, '0');
  const d = String(selectedDay.value).padStart(2, '0');
  return `${y}-${m}-${d}`;
});

const previousDateString = computed(() => {
  const d = new Date(`${selectedDateString.value}T00:00:00`);
  d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
});

function hasPreviousDayContribution(store, leafKey) {
  return Boolean((matrixPreviousDay.value[store] || {})[leafKey]);
}

const headerCats = ref([]);
const headerItems = ref([]);
const headerLeaves = ref([]);
const matrix = ref({});
const matrixPreviousDay = ref({});

const storeList = computed(() => Object.keys(matrix.value));

const leftScroll = ref(null);
const rightScroll = ref(null);
// const leftTable = ref(null);
// const rightTable = ref(null);

function onRightScroll(e) {
  if (leftScroll.value) leftScroll.value.scrollTop = e.target.scrollTop;
}

// function syncRowHeights() {
//   if (!leftTable.value || !rightTable.value) return;

//   const leftHeaderRows = leftTable.value.querySelectorAll('thead tr');
//   const rightHeaderRows = rightTable.value.querySelectorAll('thead tr');
//   const headerRowCount = Math.max(leftHeaderRows.length, rightHeaderRows.length);

//   for (let i = 0; i < headerRowCount; i++) {
//     const l = leftHeaderRows[i];
//     const r = rightHeaderRows[i];
//     if (!l || !r) continue;
//     l.style.height = '';
//     r.style.height = '';
//     const h = Math.max(Math.ceil(l.scrollHeight), Math.ceil(r.scrollHeight));
//     l.style.height = h + 'px';
//     r.style.height = h + 'px';
//   }

//   const totalRows = storeList.value ? storeList.value.length : 0;
//   for (let i = 0; i < totalRows; i++) {
//     const l = leftTable.value.querySelector(`tbody tr[data-row-index="${i}"]`);
//     const r = rightTable.value.querySelector(`tbody tr[data-row-index="${i}"]`);
//     if (!l || !r) continue;
//     l.style.height = '';
//     r.style.height = '';
//     const lh = Math.ceil(l.scrollHeight);
//     const rh = Math.ceil(r.scrollHeight);
//     const h = Math.max(lh, rh);
//     l.style.height = h + 'px';
//     r.style.height = h + 'px';
//   }

//   const lt = leftTable.value.querySelector('tbody tr[data-row-index="total"]');
//   const rt = rightTable.value.querySelector('tbody tr[data-row-index="total"]');
//   if (lt && rt) {
//     lt.style.height = '';
//     rt.style.height = '';
//     const h = Math.max(Math.ceil(lt.scrollHeight), Math.ceil(rt.scrollHeight));
//     lt.style.height = h + 'px';
//     rt.style.height = h + 'px';
//   }
// }





const uniqueLocations = computed(() => {
  return Array.from(new Set(locations.value.map(l => l.store_name)));
});

function sortLocations(list) {
  const typeOrder = { r: 0, dc: 1, o: 2 };

  return [...list].sort((a, b) => {
    const typeA = String(a?.store_type || a?.type || '').trim().toLowerCase();
    const typeB = String(b?.store_type || b?.type || '').trim().toLowerCase();

    const orderA = typeOrder[typeA] ?? 99;
    const orderB = typeOrder[typeB] ?? 99;

    if (orderA !== orderB) {
      return orderA - orderB;
    }

    const nameA = String(a?.store_name || '').trim().toLowerCase();
    const nameB = String(b?.store_name || '').trim().toLowerCase();

    return nameA.localeCompare(nameB);
  });
}

async function clearFilters() {
  filters.value = { q: '', location: '', qr: '', dateFrom: '', dateTo: '', status: '' };
}



async function loadLocations() {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_API_URL}/api/locations`,
      { headers: getAuthHeaders() }
    );
    const rawLocations = Array.isArray(data) ? data : [];
    locations.value = sortLocations(rawLocations);
    const map = {};
    for (const r of locations.value) {
      const name = (r.store_name || '').toString().trim();
      map[name] = (r.abbreviation || r.abbrev || '').toString().trim();
    }
    storeAbbrev.value = map;
  } catch (e) {
    console.error('Failed to load locations:', e);
    locations.value = [];
    storeAbbrev.value = {};
  }
}

async function loadCategoriesTree() {
  try {
    const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/categories/tree`, { headers: getAuthHeaders() });
    categoriesTree.value = data;
    buildHeaders();
  } catch (e) {
    console.error('Failed to load categories tree:', e);
  }
}

function buildHeaders() {
  const cats = {};

  for (const row of categoriesTree.value) {
    const cat = row.category || 'Uncategorized';
    cats[cat] = cats[cat] || { name: cat.replace(/_/g, ' '), items: [] };
  }

  for (const row of categoriesTree.value) {
    const cat = row.category || 'Uncategorized';
    cats[cat].items.push({
      id: row.id,
      name: row.category_name,
      bin_types: row.bin_types || []
    });
  }

  const top = [];
  const items = [];
  const leaves = [];

  const categoryOrder = tableViewCategories.filter(cName => cats[cName]);

  for (const cName of categoryOrder) {
    if (!cats[cName]) continue;

    const itList = cats[cName].items;
    let catLeafCount = 0;

    for (const it of itList) {
      const rawItemName = it.name || '';
      const cleanItem = cleanName(rawItemName);

      let allowedBinTypes;

      if (cleanItem === 'CRT') {
        allowedBinTypes = ['CRT'];
      } else if (['RT', 'RW'].includes(cleanItem)) {
        allowedBinTypes = ['Gaylord', 'Bin'];
      } else if (['Presort Text'].includes(cleanItem)) {
        allowedBinTypes = ['Cage', 'Bin', 'Gaylord']
      }
      else if (['Presort Wares'].includes(cleanItem)) {
        allowedBinTypes = ['Bin', 'Gaylord']
      }
      else {
        allowedBinTypes = ['Pallet', 'Gaylord', 'Bin', 'Tote', 'CRT'];
      }

      const btypes = Array.from(allowedBinTypes);
      catLeafCount += btypes.length;

      items.push({
        key: `${cName}||${cleanItem}`,
        name: cleanItem,
        colspan: btypes.length
      });

      for (const bt of btypes) {
        const leafKey = `${cName}||${cleanItem}||${bt}`;
        const leafName = bt ? ` ${bt}` : cleanItem;
        leaves.push({ key: leafKey, name: leafName });
      }
    }

    top.push({
      name: cName.replace(/_/g, ' '),
      colspan: catLeafCount || 1
    });
  }

  headerCats.value = top;
  headerItems.value = items;
  headerLeaves.value = leaves;
}


async function loadFulfillmentDay() {
  fulfillmentLoading.value = true;

  try {
    const [{ data: selectedData }, { data: previousData }] = await Promise.all([
      axios.get(`${process.env.VUE_APP_API_URL}/api/admin/fulfillment/day`, {
        params: { date: selectedDateString.value },
        headers: getAuthHeaders()
      }),
      axios.get(`${process.env.VUE_APP_API_URL}/api/admin/fulfillment/day`, {
        params: { date: previousDateString.value },
        headers: getAuthHeaders()
      })
    ]);

    const selectedRows = Array.isArray(selectedData) ? selectedData : [];
    const previousRows = Array.isArray(previousData) ? previousData : [];
    fulfillmentRows.value = [...selectedRows, ...previousRows];

    if (!headerLeaves.value.length) {
      if (!categoriesTree.value.length) {
        await loadCategoriesTree();
      } else {
        buildHeaders();
      }
    }

    if (!locations.value.length) {
      await loadLocations();
    }

    const leafKeys = headerLeaves.value.map(l => l.key);
    const m = {};
    const priorDayFlags = {};

    for (const loc of sortLocations(locations.value)) {
      const name = (loc.store_name || '').trim();
      m[name] = {};
      priorDayFlags[name] = {};
      for (const lk of leafKeys) {
        m[name][lk] = 0;
        priorDayFlags[name][lk] = false;
      }
    }

    for (const r of selectedRows) {
      const loc = (r.location || '').trim();
      if (!m[loc]) {
        m[loc] = {};
        priorDayFlags[loc] = {};
        for (const lk of leafKeys) {
          m[loc][lk] = 0;
          priorDayFlags[loc][lk] = false;
        }
      }

      const cat = (r.category || '').trim();
      const item = cleanName((r.category_name || '').trim());
      const bin = (r.bin_type || '').trim();
      const key = `${cat}||${item}||${bin}`;

      m[loc][key] = (m[loc][key] || 0) + (Number(r.quantity) || 0);
    }

    for (const r of previousRows) {
      const loc = (r.location || '').trim();
      if (!m[loc]) {
        m[loc] = {};
        priorDayFlags[loc] = {};
        for (const lk of leafKeys) {
          m[loc][lk] = 0;
          priorDayFlags[loc][lk] = false;
        }
      }

      const cat = (r.category || '').trim();
      const item = cleanName((r.category_name || '').trim());
      const bin = (r.bin_type || '').trim();
      const key = `${cat}||${item}||${bin}`;

      m[loc][key] = (m[loc][key] || 0) + (Number(r.quantity) || 0);
      priorDayFlags[loc][key] = true;
    }

    matrix.value = m;
    matrixPreviousDay.value = priorDayFlags;

  } catch (e) {
    console.error('Failed to load fulfillment data:', e);
    matrix.value = {};
    matrixPreviousDay.value = {};
  }

  fulfillmentLoading.value = false;

  await nextTick();
  // syncRowHeights();
  setTimeout(50);

  // if (rightTable.value && typeof ResizeObserver !== 'undefined') {
  //   const ro = new ResizeObserver(() => syncRowHeights());
  //   ro.observe(rightTable.value);
  // }
}


function getAuthHeaders() {
  const token = sessionStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const filteredRows = computed(() => {
  let list = rows.value;

  if (filters.value.location) {
    list = list.filter(r => r.location === filters.value.location);
  }

  if (filters.value.qr) {
    list = list.filter(r =>
      r.unique_qr_code?.toLowerCase().includes(filters.value.qr.toLowerCase())
    );
  }

  if (filters.value.dateFrom) {
    const from = new Date(filters.value.dateFrom);
    list = list.filter(r => new Date(r.created_at) >= from);
  }

  if (filters.value.dateTo) {
    const to = new Date(filters.value.dateTo);
    to.setDate(to.getDate() + 1);
    list = list.filter(r => new Date(r.created_at) < to);
  }

  if (filters.value.status) {
    const s = filters.value.status;
    list = list.filter(it => {
      const label = statusLabel(it);
      if (s === 'open') return label === 'Open';
      if (s === 'delivering') return label === 'Delivering' || label === 'Partially Delivered';
      if (s === 'fulfilled') return label === 'Fulfilled';
      return true;
    });
  }

  return list;
});


function statusColor(it) {
  const label = statusLabel(it);

  if (label === 'Open') return 'bg-primary';
  if (label === 'Delivering') return 'bg-warning';

  const delivered = it.delivered_quantity || 0;

  return it.fulfilled > delivered
    ? 'bg-danger'
    : 'bg-success';
}


async function load() {
  try {
    const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/admin/requests`, { headers: getAuthHeaders() });

    const adminRows = data || [];
    const uniqueQrs = [...new Set(adminRows.map(r => r.unique_qr_code).filter(Boolean))];

    const detailPromises = uniqueQrs.map(qr =>
      axios.get(`${process.env.VUE_APP_API_URL}/api/donations/${encodeURIComponent(qr)}`, { headers: getAuthHeaders() })
        .then(resp => ({ qr, donation: resp.data.donation, items: resp.data.items }))
        .catch(() => ({ qr, donation: null, items: null }))
    );

    const details = await Promise.all(detailPromises);

    const merged = [];
    for (const det of details) {
      if (det.donation && Array.isArray(det.items)) {
        for (const it of det.items) {
          merged.push({
            donation_item_id: it.donation_item_id || it.id,
            unique_qr_code: det.donation.unique_qr_code,
            location: det.donation.location,
            created_at: det.donation.created_at || det.donation.createdAt,
            submission_status: det.donation.submission_status || det.donation.status,
            username: det.donation.username,
            category_name: it.category_name,
            category: it.category,
            quantity: it.quantity,
            delivered_quantity: it.delivered_quantity,
            fulfilled: it.fulfilled,
            bin_type: it.bin_type
          });
        }
      } else {
        const fallback = adminRows.filter(r => r.unique_qr_code === det.qr);
        for (const r of fallback) merged.push(r);
      }
    }

    for (const r of adminRows.filter(r => !r.unique_qr_code)) merged.push(r);

    rows.value = merged.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    loadError.value = false;
    for (const c of displayCategories.value) {
      expanded.value[c] = expanded.value[c] ?? false;
      perCategoryPage.value[c] = perCategoryPage.value[c] ?? 1;
    }
  } catch (err) {
    console.error('Failed to load admin requests:', err);
    loadError.value = true;
  }
}

const displayCategories = computed(() => {
  return [...allowedCategories];
});

const groupedAll = computed(() => {
  const g = {};
  for (const c of displayCategories.value) g[c] = {};

  function determineCategory(r) {
    if (r.category && allowedCategories.includes(r.category)) return r.category;
    const name = (r.category_name || '').toString();
    if (allowedCategories.includes(name)) return name;
    if (/\bRP\b/i.test(name)) return 'Requested_Product';
    if (/\bDP\b/i.test(name)) return 'Delivered_Product';
    if (/reallocat/i.test(name) || /reallocated/i.test(name)) return 'Product_For_Reallocation';
    if (/on\s*hand/i.test(name)) return 'Product_On_Hand';
    if (/donation[_\s]?info/i.test(name)) return 'Donation_Info';
    return null;
  }

  for (const r of filteredRows.value) {
    const cat = determineCategory(r);
    if (!cat) continue;
    const loc = r.location || 'Unknown';
    if (!g[cat][loc]) g[cat][loc] = [];
    g[cat][loc].push(r);
  }

  for (const c of Object.keys(g)) {
    for (const loc of Object.keys(g[c])) {
      g[c][loc].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    }
  }

  return g;
});


function cleanName(name) {
  if (!name) return '';

  let cleaned = name.replace(/^#_of_/, '');

  const parts = cleaned.split('_');

  parts.pop();

  return parts.join(' ');
}




function itemsByCategory(cat) {
  const group = groupedAll.value[cat] || {};
  const arr = [];
  for (const loc of Object.keys(group)) {
    for (const it of group[loc]) {
      arr.push({ ...it, store: loc });
    }
  }
  return arr;
}


function pagedItems(cat) {
  const list = itemsByCategory(cat);
  const totalPages = Math.max(1, Math.ceil(list.length / defaultInitial));
  const page = Math.min(perCategoryPage.value[cat] || 1, totalPages);
  const start = (page - 1) * defaultInitial;

  return {
    total: list.length,
    totalPages,
    page,
    list: list.slice(start, start + defaultInitial)
  };
}

// function hasRequests(cat) {
//   const byLoc = groupedAll.value[cat] || {};
//   return Object.keys(byLoc).length > 0;
// }

function toggleCategory(cat) {
  expanded.value[cat] = !expanded.value[cat];
}

function totalCount(cat) {
  const group = groupedAll.value[cat] || {};
  return Object.values(group).reduce((s, arr) => s + arr.length, 0);
}

function goToPage(cat, page) {
  const totalPages = Math.max(1, Math.ceil(itemsByCategory(cat).length / defaultInitial));
  perCategoryPage.value[cat] = Math.min(Math.max(page, 1), totalPages);
}

function pageNumbers(cat) {
  return Array.from({ length: pagedItems(cat).totalPages }, (_, index) => index + 1);
}

function formatDate(dateStr) {
  return formatSanDiegoDateTime(dateStr);
}

function formatCategoryName(cat) {
  return cat.replace(/_/g, ' ');
}

function statusLabel(item) {
  if (item.fulfilled && item.fulfilled > 0) return 'Fulfilled';
  if (item.delivered_quantity && item.delivered_quantity >= item.quantity) return 'Delivering';
  if (item.delivered_quantity && item.delivered_quantity > 0) return 'Partially Delivered';
  return 'Open';
}

function canSendDelivery(item) {
  return Number(item.delivered_quantity || 0) === 0;
}

// async function completeItem(item) {
//   if (!confirm(`Mark ${item.category_name} on ${item.unique_qr_code} as complete?`)) return;
//   completing.value[item.donation_item_id] = true;
//   try {
//     await axios.post(`${process.env.VUE_APP_API_URL}/api/donations/${encodeURIComponent(item.unique_qr_code)}/confirm`, {
//       donation_item_id: item.donation_item_id,
//       needs_more: false,
//       quantity: item.quantity
//     }, { headers: getAuthHeaders() });
//     await load();
//   } catch (err) {
//     console.error('Failed to complete item:', err);
//   } finally {
//     completing.value[item.donation_item_id] = false;
//   }
// }


async function sendItem(item) {
  const qty = Number(sendQuantities.value[item.donation_item_id] || 0);
  if (!canSendDelivery(item)) return;
  if (!qty || qty <= 0) return;
  sending.value[item.donation_item_id] = true;
  try {
    await axios.post(`${process.env.VUE_APP_API_URL}/api/admin/deliveries`, {
      unique_qr_code: item.unique_qr_code,
      items: [{ donation_item_id: item.donation_item_id, quantity_sent: qty }]
    }, { headers: getAuthHeaders() });
    sendQuantities.value[item.donation_item_id] = 0;
    await load();
  } catch (err) {
    console.error('Failed to send item:', err);
  } finally {
    sending.value[item.donation_item_id] = false;
  }
}

const columnTotals = computed(() => {
  const totals = {};
  for (const leaf of headerLeaves.value) {
    totals[leaf.key] = 0;
  }
  for (const store of storeList.value) {
    const row = matrix.value[store] || {};
    for (const leaf of headerLeaves.value) {
      const v = Number(row[leaf.key] || 0);
      totals[leaf.key] += v;
    }
  }
  return totals;
});

const normalize = (str) => {
  return String(str || '')
    .replace(/_/g, ' ')
    .trim()
    .toLowerCase();
};

const truckSpace = computed(() => {
  const result = {};

  for (const store of storeList.value) {
    let used = 0;

    for (const leaf of headerLeaves.value) {
      let qty = matrix.value?.[store]?.[leaf.key];

      if (qty == null) {
        const [leafCat, leafItem, leafBin] = leaf.key.split("||");

        const normLeafCat = normalize(leafCat);
        const normLeafItem = normalize(leafItem);
        const normLeafBin = normalize(leafBin);

        const matchKey = Object.keys(matrix.value?.[store] || {}).find(k => {
          const [mCat, mItem, mBin] = k.split("||");
          return (
            normalize(mCat) === normLeafCat &&
            normalize(mItem) === normLeafItem &&
            normalize(mBin) === normLeafBin
          );
        });

        qty = matchKey ? matrix.value[store][matchKey] : 0;
      }

      const bt = leaf.name.trim();

      let spacePerUnit = 0;
      if (bt === "Gaylord") spacePerUnit = 20 / 12;
      else if (bt === "Bin") spacePerUnit = 20 / 20;
      else if (bt === "Tote") spacePerUnit = 20 / 30;
      else if (bt === "Pallet") spacePerUnit = 20 / 25;
      else if (bt === "CRT") spacePerUnit = 20 / 15;
      else if (bt === "Cage") spacePerUnit = 20 / 12;

      used += qty * spacePerUnit;
    }

    result[store] = used;
  }

  return result;
});




// const totalTruckSpace = computed(() => {
//   return Object.values(truckSpace.value).reduce((a, b) => a + b, 0);
// });



const notesModalOpen = ref(false);
const notesModalStore = ref('');
const notesList = ref([]);
const notesLoading = ref(false);

function formatNoteDate(dt) {
  return formatSanDiegoDateTime(dt, {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
}

/*async function openNotes(store) {
  notesModalStore.value = store;
  notesModalOpen.value = true;
  notesLoading.value = true;
  notesList.value = [];

  try {
    const abbrev = storeAbbrev.value[store] || '';
    const { data } = await axios.get(
      `${process.env.VUE_APP_API_URL}/api/admin/donations/comments`,
      {
        params: {
          abbrev,
          date: selectedDateString.value
        },
        headers: getAuthHeaders()
      }
    );
    notesList.value = Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('Failed to load notes:', e);
    notesList.value = [];
  } finally {
    notesLoading.value = false;
  }
}

function closeNotes() {
  notesModalOpen.value = false;
}*/

// function scrollToCategory(catName) {
//   const el = document.getElementById('cat-' + catName);
//   if (el) {
//     el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
//   }
// }


watch(viewByStore, (isStoreView) => {
  document.body.style.overflow = isStoreView ? 'hidden' : '';
  if (!isStoreView) {
    showStoreOverlayControls.value = false;
  }
});

onMounted(() => {
  nextTick(() => {
    if (rightScroll.value && leftScroll.value) {
      rightScroll.value.addEventListener('scroll', onRightScroll, { passive: true });
    }

    // window.addEventListener('resize', syncRowHeights);
  });

  loadLocations();
  loadCategoriesTree();
  loadFulfillmentDay();

  load();

  refreshInterval = setInterval(() => {
    load();
    loadFulfillmentDay();
  }, 90_000);
});

onUnmounted(() => {
  if (refreshInterval) clearInterval(refreshInterval);

  if (storeOverlayTimer) clearTimeout(storeOverlayTimer);
  document.body.style.overflow = '';


  if (rightScroll.value) {
    rightScroll.value.removeEventListener('scroll', onRightScroll);
  }
  // window.removeEventListener('resize', syncRowHeights);
});

</script>

<style scoped>
.fulfillment-table td,
.fulfillment-table th {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 1 !important;
  text-align: center !important;
  vertical-align: middle !important;
}

.fixed-table {
  text-align: left !important;
}

.fixed-table td,
.fixed-table th {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 1 !important;
  text-align: inherit !important;
  vertical-align: middle !important;
}

.store-view-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: #fff;
  padding: 0;
  overflow: auto;
}

.store-view-shell {
  width: 100%;
  height: 100%;
  max-width: none;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
}

.store-view-body {
  height: 100%;
  width: 100%;
  padding: 0.75rem 0 0.75rem 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.store-table-wrapper {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
}

.fulfillment-container {
  width: 100%;
  min-width: 100%;
  align-items: flex-start;
}

.fulfillment-fixed {
  flex: 0 0 auto;
}

.fulfillment-scroll {
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  overflow-y: auto;
  text-align: center;
}

.fulfillment-table thead tr:nth-child(2) th {
  border-right: 3px solid #000 !important;
}

.fulfillment-table thead tr:nth-child(2) th:last-child {
  border-right: none !important;
}

.item-header {
  border-right: 4px solid #000 !important;
}

.item-header:last-child {
  border-right: none !important;
}

.fulfillment-table td.leaf-divider,
.fulfillment-table th.leaf-divider {
  border-right: 4px solid #000 !important;
}

.overlay-back-button {
  position: fixed;
  left: 50%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 2100;
  background: rgba(255, 255, 255, 0.9);
}

.overlay-back-button-visible {
  opacity: 1;
  pointer-events: auto;
}

.fixed-crew-row td {
  background-color: #ffe680 !important;
}

.category-table-layout {
  min-width: 0;
}

.category-table-content {
  min-height: 43rem;
  min-width: 0;
}

.category-pagination-footer {
  background-color: #f8f9fa;
  text-align: left;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.background-black {
  background-color: #000 !important;
  color: #000000 !important;
  border: black !important;
  border-bottom: black !important;
  border-top: black !important;
}

.table {
  border-color: black !important;
}

.fulfillment-container tbody tr.hovered-store-row>* {
  background-color: #d3d3d3 !important;
  color: #000 !important;
}

.fulfillment-container tbody tr.hovered-store-row>td.background-black {
  background-color: #000 !important;
  color: #000 !important;
}

.fulfillment-container tbody tr.hovered-total-row>* {
  background-color: var(--accent-peach) !important;
}

.order-link {
  color: #c04904;
}

.table tbody tr:hover .order-link,
.order-link:hover {
  color: #fff !important;
}
</style>